// extracted by mini-css-extract-plugin
export default {"skeleton-img-wrapper":"_AQehc","skeleton-img":"mPBHDm","skeleton-price":"_0a2qw","skeleton-button":"Mcwzdp"};